import {
  APARTMENT_GALLERY_VIEW_TAB_ORDER,
  getEnabledGalleryViews,
  type ApartmentGalleryViewId,
  type ApartmentGalleryViews,
} from '@/lib/apartments/apartmentGallery'

export type RoomGalleryTabLabels = Record<ApartmentGalleryViewId, string>

export function getGalleryViewTabIds(): ApartmentGalleryViewId[] {
  return APARTMENT_GALLERY_VIEW_TAB_ORDER
}

export function getEnabledGalleryViewTabIds(views: ApartmentGalleryViews): ApartmentGalleryViewId[] {
  return getEnabledGalleryViews(views)
}

export function isGalleryViewEnabled(
  views: ApartmentGalleryViews,
  view: ApartmentGalleryViewId,
): boolean {
  return getEnabledGalleryViews(views).includes(view)
}

export function getDefaultGalleryView(views: ApartmentGalleryViews): ApartmentGalleryViewId {
  return getEnabledGalleryViews(views)[0] ?? 'gallery'
}

export function moveGalleryViewTabFocus(
  enabledTabs: ApartmentGalleryViewId[],
  current: ApartmentGalleryViewId,
  key: 'ArrowLeft' | 'ArrowRight' | 'Home' | 'End',
): ApartmentGalleryViewId {
  if (enabledTabs.length === 0) return 'gallery'

  const currentIndex = enabledTabs.indexOf(current)
  const resolvedCurrent = currentIndex === -1 ? enabledTabs[0]! : current

  if (key === 'Home') return enabledTabs[0]!
  if (key === 'End') return enabledTabs[enabledTabs.length - 1]!

  const resolvedIndex = enabledTabs.indexOf(resolvedCurrent)
  const direction = key === 'ArrowRight' ? 1 : -1
  const nextIndex = (resolvedIndex + direction + enabledTabs.length) % enabledTabs.length
  return enabledTabs[nextIndex]!
}
